<template>
  <div id="ranking-board">
    <div class="ranking-board-title">工单用户排名</div>
    <dv-scroll-ranking-board :config="config" />
  </div>
</template>

<script>
import {mapGetters} from "vuex";

var intervalEvent;
export default {
  name: 'RankingBoard',
  // props: ['subData'],
  computed: {...mapGetters(['rankingList'])},
  data () {
    return {
      config: {
        data: [],
        rowNum: 8
      },
      loaded:false,
    }
  },
  async mounted(){
    await this.$store.dispatch('screen/screenSet',{}).then(Response=>{
      this.createData()
      // console.log('this.rankingList',this.rankingList)
      // this.config.data=this.rankingList;
    });
  },

  async created(){
    // await this.$store.dispatch('screen/screenSet',{}).then(Response=>{
    //   this.createData()
    // });


    // this.createData();

    if (!this.loaded){
      intervalEvent=setInterval(this.createData, 3000)
    }

    


  },

  methods: {
    createData () {
      if (this.rankingList.length>0){
        const { config } = this;
        this.config.data = this.rankingList;
        this.config = { ...this.config }

        this.loaded=true;
        clearInterval(intervalEvent);  
      }
    }
  }
}
</script>

<style lang="less">
#ranking-board {
  width: 20%;
  box-shadow: 0 0 3px blue;
  display: flex;
  flex-direction: column;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  box-sizing: border-box;
  padding: 0px 30px;

  .ranking-board-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
  }

  .dv-scroll-ranking-board {
    flex: 1;
  }
}
</style>
